module.exports = __webpack_public_path__ + "media/images/background/login-background-3dc47b4dcb26e205b9cdcded48e059af.jpg";